import React, { Component } from 'react';
import cx from 'classnames';
import { setPopUp } from 'actions/environment';
import { connect } from 'react-redux';

import PayForTarif from '../PayForTarif';
import s from './style';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';

@connect(null, { setPopUp })
class PayForTarifBtn extends Component {
  payForTarif = async () => {
    tracker.sendEvent('Web_Profile_Renew_Subscription');

    const { setPopUp } = this.props;
    setPopUp(
      <PayForTarif />
      ,
      { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false }
    );
  }

  render() {
    const { className, t } = this.props;
    const classes = cx(className, s.root, 'button-primary', 'button-primary--lg');
    return (
      <button className={classes} onClick={this.payForTarif}>
        {this.props.children || t('components.payments.payForTarif.button')}
      </button>
    );
  }
}

export default withTranslation()(PayForTarifBtn);



// WEBPACK FOOTER //
// ./src/components/Payments/PayForTarifBtn/PayForTarifBtn.js